import { Injectable } from '@angular/core';

import { CommunicationDaoService } from '../communication-dao.service';
import { ServerConfig } from 'src/app/_model/server-config';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';

// CONSTANTS
const CONFIG_KEY = 'server_conf';

/**
 * DataAccessObject for Communication Configurations
 */
@Injectable()
export class CommunicationStorageDaoService implements CommunicationDaoService {
  // LifeCycle
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  // CommunicationDaoService
  public async saveServerConfig(serverConfig: ServerConfig): Promise<void> {
    await this.keyValueStorage.store(CONFIG_KEY, serverConfig);
  }

  public async loadServerConfig(): Promise<ServerConfig> {
    return await this.keyValueStorage.load(CONFIG_KEY);
  }
}
